/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import SelectField from 'components/Form/SelectField';
import { FastField, Field, FieldArray, Form, Formik } from 'formik';

import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    DialogSelect,
    DialogCancel,
    DialogConfirm,
} from './styles';

const mc = new MessageCenter();
const fitinsurApi = new FitinsurAPI();

export default function ModalLost({ idOperation, show, setDialog, history }) {
    const [visible, setVisible] = useState(show);
    const [lostDeal, setLostDeal] = useState({ formated: [], array: [] });

    const authContext = useContext(GlobalAuthContext);
    const myRef = useRef();
    const lostReasonsRef = useRef();

    useEffect(() => {
        setVisible(show);
    }, [show]);

    useEffect(() => {
        async function request() {
            fitinsurApi.setAuthToken(authContext.token);
            const data = await fitinsurApi.requestLostDealList().then((response) => response.json());

            try {
                if (data.ret_code != 200) {
                    mc.error("fitGetLostReason - REQUEST ERROR => " + JSON.stringify(data))
                    console.log(data);
                    return;
                }

                if (data.ret_value) {
                    const formatedOptions = data.ret_value.map(listOption => ({
                        label: listOption.ANSWER_OPTION_DESCRIPTION,
                        value: listOption.ID_ANSWER_OPTION
                    }));
                    setLostDeal({ formated: formatedOptions, array: data.ret_value });
                } else {
                    console.log("fitGetLostReason - UNEXPECTED NULL RETURNED DATA => " + JSON.stringify(data));
                }
            } catch (error) {
                mc.error(`There was an error while fetching your data: ${ModalLost.name}\n` + error);
                console.error('fitGetLostReason - Error:', error);
                setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
            };
        }

        request();
    }, [])

    const HandleLostSubmit = (selectedID) => {
        if (!selectedID) {
            mc.error("Please, select at least one option.");
            return;
        }
        fitinsurApi.setAuthToken(authContext.token);
        fitinsurApi.updateQuoteEdit(idOperation, selectedID).then(x => x.json()).then(res => {
            console.log(res)
            if (res.ret_code != 200) {
                mc.error(res.ret_msg_details);
                return;
            }
            history.push("/list");
            /* setDialog({ visible: false, title: null, icon: null, args: null });
            lostReasonsRef.current?.setFieldValue('reasons', ''); */
        })
    }

    return (
        <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
                <DialogIcon>
                    <FontAwesomeIcon icon={['fas', 'times-circle']}></FontAwesomeIcon>
                    <DialogText>LOST DEAL</DialogText>
                </DialogIcon>
                <Formik initialValues={{ reasons: '' }} innerRef={lostReasonsRef} onSubmit={(e) => { HandleLostSubmit(e.reasons); }}>
                    <Form>
                        <DialogSelect>
                            <Field
                                disabled={false}
                                name="reasons"
                                placeholder="Select the reason the deal was lost"
                                component={SelectField}
                                options={lostDeal.formated}
                            />
                        </DialogSelect>
                        <DialogCancel onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDialog(false); lostReasonsRef.current?.setFieldValue('reasons', ''); }}>Cancel</DialogCancel>
                        <DialogConfirm type="submit">Confirm</DialogConfirm>
                    </Form>
                </Formik>
            </DialogBody>
        </Dialog>
    );
}